const TextPlaceholder = ({ placeholder }: { placeholder: string }) => (
  <div className="c-editor-placeholder">{placeholder}</div>
)

export default TextPlaceholder
